import { ButtonPanel, Modal, useWindowWidth } from '@prishapolicy/shared/ui';
import { Dispatch, SetStateAction } from 'react';

export const GlossaryModal = ({
  isOpen,
  setIsOpen,
  content,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  content: {
    englishTitle: string;
    englishContent?: string;
    hindiContent?: string;
    hindiTitle?: string;
  };
}) => {
  const { isLg } = useWindowWidth();
  return (
    <Modal
      isOpen={isOpen}
      closeModal={() => setIsOpen(false)}
      title="Glossary Words"
      headerSide={isLg ? 'left' : 'top'}
    >
      <div className="text-title-7 font-bold">{content?.englishTitle}</div>
      <div className="mt-4">{content?.englishContent}</div>
      {content?.hindiContent !== ' ' && (
        <>
          <div className="bg-grey-200 mt-4 h-[1px]"></div>
          <div className="text-title-7 mt-4 font-bold">{content?.hindiTitle}</div>
          <div className="mt-4 mb-4">{content?.hindiContent}</div>
        </>
      )}
      <ButtonPanel
        primaryButtonInfo={{
          text: 'Done',
          onClick: () => setIsOpen(false),
        }}
      />
      <div className="mb-15 xl:mb-0" />
    </Modal>
  );
};
